<template>
  <div  v-draggable="draggableValue" class="remidersBox">
    <div class="notes-wrap-modal">
      <div class="modal-body pad0" v-if="showaddreminder">
        <div class="modal-top-head">
          <h2 @click="backtoReminders()">
            <vs-icon icon="keyboard_backspace" size="small"></vs-icon>{{editReminder?'Edit':'Add'}} Reminder
          </h2>
        </div>
      
        <div class="modal-content-wrap" > 
          
          <form data-vv-scope="createreminder">
            <div class="form-container reminder_form">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="form_group">
                    <label class="form_label">Title<em>*</em></label>
                    <vs-input :key="'Name'"
                      class="w-full"
                      name="Name"
                      icon-pack="feather"
                      v-validate="'required'"
                      data-vv-as="Title"  
                      icon-after 
                      v-model="reminder.name"
                    />

                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('createreminder.Name')"
                  >{{ errors.first("createreminder.Name") }}</span>
                </div>
                </div>

                <div class="vx-col w-full">
                  <div class="form_group">
                  <label class="form_label" >Due Date<em>*</em></label>
                  <!-- <date-range-picker  v-validate="'required'" :autoApply="autoApply" :ranges="false"   name="DueDate" v-model="reminder.dueDate" ></date-range-picker>
                  <span  class="text-danger text-sm"  v-show="errors.has('DueDate')"  >{{ errors.first("DueDate") }}</span>-->
                  <div class="vs-component">
                  <datepicker  :typeable="true"
                    name="DueDate"
                  
                   :disabled-dates="{to: new Date(startEligibleDate)}"
                     data-vv-as="Due Date"  
                    
                    v-model="reminder.dueDate"
                    v-validate="'required'"
                    placeholder="MM/DD/YYYY"
                  ></datepicker>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('createreminder.DueDate')"
                  >{{ errors.first("createreminder.DueDate") }}</span>
                </div></div>
                </div>

                <div class="vx-col w-full">
                  <div class="form_group">
                    <label class="form_label">Description<em>*</em></label>
                  <!-- <vs-textarea
                    name="Description"
                    v-validate="'required'"
                    v-model="reminder.description" 
                    class="w-full"
                  /> -->
                  <ckeditor name="Description"
                    v-validate="'required'"
                    v-model="reminder.description" 
                    class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>

                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('createreminder.Description')"
                  >{{ errors.first("createreminder.Description") }}</span>
                </div>
                </div>
              </div>
            </div>
            

            <div class="modal-bottom-foot pad0">
          <div class="modal-bot-foot-inner">
            
            
            <div class="modal-bot-foot-innerleft">
              
              <vs-button
              v-if="editReminder"
                color="savebtn"
                class="w-full save"
                type="filled"
                v-on:click="updateReminder"
              >Update</vs-button>
              <vs-button
               v-else
                color="savebtn"
                class="w-full save"
                type="filled"
                v-on:click="saveReminder"
              >Save</vs-button>
              
            </div>
            <div class="modal-bot-foot-innerright">
              <vs-button
                color="cancelbtn"
                class="cancel"
                type="filled"
                @click="backtoReminders()"
              >Cancel</vs-button>
            </div>
          </div>
        </div>
          </form> 
          
        </div>
 
      </div>

      <div class="modal-body pad0" v-if="showreminders">
        <div class="modal-top-head">
          <h2>Reminders</h2>
          
           <!-- <vs-dropdown vs-custom-content vs-trigger-click >
            <vs-button class="btn-drop filter_dropdown" icon-pack="feather" icon="icon-chevron-down"><img src="@/assets/images/main/icon-filter.svg" />Filters</vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="changedstatus(item.id)"
                v-for="(item, index) in reminderstatus_list"
                :key="index"
              >{{ item.name }}</vs-dropdown-item> 
            </vs-dropdown-menu>
          </vs-dropdown> -->

            <div class="vertical-menu reminder_filters">
              <span class="menu-icon">
                <vs-button class="btn-drop filter_dropdown" icon-pack="feather" icon="icon-chevron-down"><img src="@/assets/images/main/icon-filter.svg" />Filters</vs-button>
              </span>
              <div class="menu__list">
              <ul>
                <li @click="changedstatus(item.id)"  v-for="(item, index) in reminderstatus_list"  :key="index" >{{ item.name }}</li>                
              </ul>
              </div>
            </div>
          

         <!-- <multiselect
                      v-model="selectedStatus"
                      :options="reminderstatus_list"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Filter Status"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                       @input="filterByStatus"
                    > 
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Status(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                    -->

          
        </div>
        <VuePerfectScrollbar class="scroll-area"  > 
        <div class="modal-content-wrap 1">
          
          <div class="notes" v-if="reminders.length > 0"> 
            <ul class="list-unstyled">
              <li
                class="media ng-star-inserted"
                v-for="(remideritem, index) in reminders"
                :key="index"
              >
                <div class="media-body">
                  <div class="media-top dd">
                    <div class="d-flex align-items-center">
                      <h5 class="pointer">{{remideritem.name}}</h5>

                      <button class="norm-btn due-date" :class="{'complete':isOverDue(remideritem.dueDate)}">
                        {{isOverDue(remideritem.dueDate)?'Over ':''}} Due:&nbsp;{{ remideritem.dueDate | formatDate }}
                      </button>

                      <button
                        v-if="remideritem.statusId!=1 && remideritem.statusDetails"
                        class="norm-btn closed"
                      >{{remideritem.statusDetails.name}}</button>
                    </div>

                    <div class="d-flex align-items-center" v-if="[1,2].indexOf(remideritem.statusId)>-1">
                      <div class="notes-list show dropdown" style="position:relative">
                        <div class="vertical-menu">
                          <span class="menu-icon">
                            <i class="material-icons">more_vert</i>
                          </span>
                          <ul>
                           
                            <li v-if="remideritem.statusId==1" @click="showaddpopup(remideritem)">Edit</li>
                            <li v-if="remideritem.statusId==1" @click="updateReminderStatus(remideritem,2)">Complete</li>
                            <li v-if="[1,2].indexOf(remideritem.statusId)>-1" @click="updateReminderStatus(remideritem,3)">Remove</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p>{{ remideritem.description}}</p>
                  <span>{{ remideritem.createdOn | formatDate }}</span>
                </div>
              </li>
            </ul>
          </div>

          <div v-if="reminders.length == 0 && !showLoader" class="no-notes-panel ng-star-inserted">
            <div class="no-notes">
              <figure>
                <img _ngcontent-c4 src="@/assets/images/no-notes-image.svg" />
              </figure>
              <h3>No Reminders Yet.</h3>
            </div>
          </div>

          <div v-if="showLoader" class="loader"><img src="@/assets/images/main/loader.gif"></div>
           
        </div>
        </VuePerfectScrollbar>
        <div class="modal-bottom-foot">
          <div class="modal-bot-foot-inner">
            <div class="modal-bot-foot-innerleft">
              <vs-button
                color="savebtn"
                class="w full save"
                type="filled"
                v-on:click="showaddpopup()"
              >Add Reminder</vs-button>
            </div>
            <div class="modal-bot-foot-innerright">
              <vs-button
                color="cancelbtn"
                class="cancel"
                type="filled"
                v-on:click="hideReminderscomponent()"
              >Cancel</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.topdata .vdp-datepicker__calendar{
position: absolute !important;
top: -312px !important;
}
</style>
<script>
import { Draggable } from "draggable-vue-directive";
import DateRangePicker from "vue2-daterange-picker";
import Paginate from "vuejs-paginate";
import Datepicker from "vuejs-datepicker-inv";
import Multiselect from "vue-multiselect-inv";
import JQuery from "jquery";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


import * as _ from "lodash";
  import moment from 'moment'
export default {
  directives: {
    Draggable,
  },
  components: {
    Datepicker,
    DateRangePicker,
    Multiselect,
    Paginate,
    VuePerfectScrollbar
     
      
  },
  data: () => ({
    editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },

    startEligibleDate: new Date(new Date().getTime() - 24*60*60*1000),
    reminder: {},
    draggableValue:{
      },
    SubmtRminder: false,
    reminders: [],
    selectedStatus:{"id":1,"name":"Active"},
    reminderstatus_list: [],
    selected_statusId: 1,
    showreminders: true,
    showaddreminder: false,
    editReminder:false,
    options:{
        height:'100%',
        size:0
    },
    showLoader:false
  }),
  watch: {},
  methods: {
    isOverDue(date){
      let toDay = moment()
      let dbDate = moment(date);

 
      if(dbDate.isBefore(toDay)){
        return false;
      }else{
        return true;

      }
      

    },
    hideReminderscomponent(){
    this.$emit("hidereminders");
    

    },
    backtoReminders() {
      //reminder.name reminder.dueDate reminder.description
      this.reminder ={ name:'', dueDate:'',  description:'' };
      this.showreminders = true;
      this.showaddreminder = false;
      this.editReminder =false;
    },
    showaddpopup(selectedItem=null) {
      this.showreminders = false;
      this.showaddreminder = true;
      this.editReminder =false;
     
      if(selectedItem !=null && _.has( selectedItem ,'_id')  ){

       
        this.reminder = { name:'', dueDate:'',  description:''  ,"reminderId":''};
         this.reminder['name'] = selectedItem['name'];
        this.reminder['reminderId'] = selectedItem['_id'];
        this.reminder['dueDate'] = selectedItem['dueDate'];
        this.reminder['description'] = selectedItem['description'];


        this.editReminder =true;
      }
       this.showaddreminder = true;
    },
    saveReminder() {
      this.$validator.validateAll("createreminder").then((result) => {
        if (result) {
          this.$store
            .dispatch("submitRminder", this.reminder)
            .then((response) => {
             
              this.showToster({message:response['message'] ,isError:false});              
              this.$emit('reloadRemindersCount');
              this.reminder = {
                name: "",
                description: "",
                dueDate: new Date(),
              };
              this.getReminderlist();
              this.$validator.reset();
              this.backtoReminders();
            })
            .catch((err) => {
               this.showToster({message:err ,isError:true});     

            });
        }
      });
    },
    showRemiderPopup() {},
    filterByStatus(item){
    
      this.selected_statusId =1;
     // this.selectedStatus =  {"id":1,"name":"Active"};
      if(_.has(item ,"id")){
         this.selected_statusId = item['id'];
      }
       this.getReminderlist();

    },
    changedstatus(statusId) {
      this.selected_statusId = statusId;
      this.getReminderlist();
    },
    getReminderlist() {
      let post_data = {
        page: 1,
        perpage: 10000,
        today: new Date(),
        matcher: {},
      };
      post_data["matcher"]["statusIds"] = [this.selected_statusId];
      this.showLoader =true;
      this.$store.dispatch("submitRminderList", post_data).then((response) => {
        this.showLoader =false;
        this.reminders = response["data"]["result"]["list"];
      })
      .catch((err)=>{
        this.showLoader =false;

      })
    },
    ///reminders/update-status

    updateReminder() {
         


      this.$store
        .dispatch("updateReminder", this.reminder)
        .then((response) => {

          this.showToster({message:response.message,isError:false })
        
          this.getReminderlist();
          this.$validator.reset();
          this.backtoReminders();
        })
        .catch((err) => {});
    },

    updateReminderStatus(reminder, statusId) {
     
      reminder["statusId"] = statusId;
      reminder["reminderId"] = reminder._id;
      reminder["statusName"] ='Active';
      if(statusId ==2){
        reminder["statusName"]  ="Completed";

      }else if(statusId ==3){
        reminder["statusName"]  ="Removed";

      }


      this.$store
        .dispatch("updateReminderStatus", reminder)
        .then((response) => {

          this.showToster({message:response.message,isError:false })
        
          this.getReminderlist();
          this.$emit('reloadRemindersCount');
        })
        .catch((err) => {});
    },
  },

  mounted() {
    this.username = this.$store.state.user.name;
    this.roleId = this.$store.state.user["roleId"][0];
    this.reminderstatus_list = [
      {
        id: 1,
        name: "Active",
      },
      {
        id: 2,
        name: "Completed",
      },
      {
        id: 3,
        name: "Removed",
      },
    ];

    this.getReminderlist();
  },
};
</script>
